import {
    IMappingProfile,
    IQueryParams,
    IQueryParamsSymbol,
    PFOrdersEntities,
} from '@pf/shared-common';
import { createMap, Mapper } from '@automapper/core';
import {
    entitySymbols,
    withDefaultEntityMetadata,
    withDefaultSearchParamsMetadata,
    withMetadata,
    withSearchFilter,
} from '@pf/shared-utility';
import {
    PurchaseOrderLineCreate,
    PurchaseOrderLineDto,
    PurchaseOrderLineRead,
    PurchaseOrderLineSearchParams,
} from '../../entities/purchase-order-line.dto';
import {
    CurrencySymbol,
    CustomFieldMetadataMap,
    ResourceAuthSymbol,
} from '@pf/shared/util-platform';

const symbols = entitySymbols(PFOrdersEntities.PurchaseOrderLine);

withDefaultEntityMetadata<PurchaseOrderLineDto>(symbols.dto, {
    customFields: [CustomFieldMetadataMap.symbols.dto],
    item: [Object],
    itemId: String,
    itemPrice: CurrencySymbol,
    lineNumber: String,
    notes: String,
    purchaseOrderHeaderId: String,
    quantity: Number,
    requisitionId: String,
    requisitionLineId: String,
    resourceAuth: ResourceAuthSymbol,
    status: String,
    totalPrice: CurrencySymbol,
});

withDefaultEntityMetadata<PurchaseOrderLineRead>(symbols.entity, {
    customFields: [CustomFieldMetadataMap.symbols.entity],
    item: [Object],
    itemId: String,
    itemPrice: CurrencySymbol,
    lineNumber: String,
    notes: String,
    purchaseOrderHeaderId: String,
    quantity: Number,
    requisitionId: String,
    requisitionLineId: String,
    resourceAuth: ResourceAuthSymbol,
    status: String,
    totalPrice: CurrencySymbol,
});

withMetadata<PurchaseOrderLineCreate>(symbols.createBody, {
    itemId: String,
    itemPrice: CurrencySymbol,
    lineNumber: String,
    notes: String,
    quantity: Number,
    requisitionId: String,
    requisitionLineId: String,
    resourceAuth: ResourceAuthSymbol,
    status: String,
    totalPrice: CurrencySymbol,
});

withDefaultSearchParamsMetadata<PurchaseOrderLineSearchParams>(
    symbols.searchParams,
    {
        purchaseOrderHeaderId: String,
        requisitionLineId: String,
        requisitionId: String,
        status: String,
        itemId: String,
    }
);

export const PurchaseOrderLineMetadataMap: IMappingProfile = {
    symbols,
    profile: (mapper: Mapper) => {
        createMap<PurchaseOrderLineRead, PurchaseOrderLineDto>(
            mapper,
            symbols.entity,
            symbols.dto
        );
        createMap<PurchaseOrderLineDto, PurchaseOrderLineRead>(
            mapper,
            symbols.dto,
            symbols.entity
        );
        createMap<PurchaseOrderLineDto, PurchaseOrderLineCreate>(
            mapper,
            symbols.dto,
            symbols.createBody
        );
        createMap<
            IQueryParams<PurchaseOrderLineDto>,
            PurchaseOrderLineSearchParams
        >(
            mapper,
            IQueryParamsSymbol,
            symbols.searchParams,
            withSearchFilter('purchaseOrderHeaderId'),
            withSearchFilter('requisitionLineId'),
            withSearchFilter('requisitionId'),
            withSearchFilter('status'),
            withSearchFilter('itemId')
            // TODO not working because of required parentId
            // ...withDefaultSearchParamsMappingConfiguration()
        );
    },
};
